<template>
    <Teleport to="body">
        <template v-if="modelValue">
            <div
                :id="modalId"
                class="modal fade show d-block"
                tabindex="-1"
                role="dialog"
                :aria-labelledby="`${modalId}Label`"
                aria-modal="true"
                @click.self="close"
                @keydown.esc="close"
            >
                <div class="modal-dialog modal-dialog-centered" :class="modalSizeClass" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" :id="`${modalId}Label`">
                                <slot name="title">{{ title }}</slot>
                            </h5>
                            <button type="button" class="close" aria-label="Close" @click="close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <slot></slot>
                        </div>
                        <div class="modal-footer" v-if="!hideFooter">
                            <slot name="footer">
                                <button type="button" class="btn btn-secondary" @click="close">Cancel</button>
                                <button type="button" class="btn btn-primary" @click="$emit('save')">Save</button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-backdrop fade show"></div>
        </template>
    </Teleport>
</template>

<script>
export default {
    name: 'BaseModal',
    emits: ['save', 'update:modelValue'],
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        modalId: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: 'Modal',
        },
        size: {
            type: String,
            default: 'md', // sm, md, lg, xl
            validator: (value) => ['sm', 'md', 'lg', 'xl'].includes(value),
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        modalSizeClass() {
            const sizeMap = {
                sm: 'modal-sm',
                md: '',
                lg: 'modal-lg',
                xl: 'modal-xl',
            };
            return sizeMap[this.size];
        },
    },
    methods: {
        close() {
            this.$emit('update:modelValue', false);
        },
    },
};
</script>
